import { Entry } from '../Entry'

export function Entry20260121() {
  return (
    <Entry title="2026 Jan 21 - v3.11.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/21111/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
